import script from "./select.vue?vue&type=script&lang=ts&setup=true"
export * from "./select.vue?vue&type=script&lang=ts&setup=true"

import "./select.vue?vue&type=style&index=0&id=f08db1e0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f08db1e0"]])

export default __exports__